/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

type Props = {
  message: string;
};

const ArticleDisclaimerText = ({ message }: Props) => (
  <Typography2
    css={css`
      margin-top: 10px;
    `}
    variant="bodySecondary"
    color="supportText"
    component="p"
  >
    {message}
  </Typography2>
);

export default ArticleDisclaimerText;
